import axios from "../../../../axios";
import Cookies from "js-cookie";
import API_BASE_URL from "../../../config/runtimeConfig";

export const GetPublishedJobs = async () => {
  const token = Cookies.get("ConsultantToken");

  return axios.post("/api/Consultant/GetPublishedJobs", {
    token,
  });
};

// services/jobService.js
export const getJobDetails = async (jobUID) => {
  const token = Cookies.get("ConsultantToken");
  return axios.post("/api/Consultant/GetJobDetails", {
    token,
    jobUID,
  });
};

export const getSentCandidateforJob = async (jobUID) => {
  const token = Cookies.get("ConsultantToken");
  return axios.post("/api/Consultant/GetSentCandidatesForJob", {
    token,
    jobUID,
  });
};

export const viewResume = (resumePath) => {
  const token = Cookies.get("ConsultantToken");
  return `${API_BASE_URL}/api/Metadata/${encodeURIComponent(
    resumePath
  )}/${token}`;
};


export const GetCandidateDetails = async (submitedCandidateUID) => {
  const token = Cookies.get("ConsultantToken");

  return axios.post(
    "/api/Consultant/GetCandidateDetails",
    {
      token,
      submitedCandidateUID,
    },
    {
      validateStatus: () => true
    }
  );
};